import { Grid } from '@material-ui/core';
import React, { useMemo } from 'react';
import CustomCard from '../../shared/CustomCard';
import ReactInfiniteScroll from '../../common/ReactInfiniteScroll';
import { sortItemsBySelection } from '../utils';

const DealershipList = ({ filteredDealershipArray, data, handleDataChange }) => {
  const sorted = useMemo(
    () => sortItemsBySelection(data.dealerships, filteredDealershipArray, 'id'),
    [data?.dealerships, filteredDealershipArray],
  );

  return (
    <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start">
      <ReactInfiniteScroll
        size={20}
        data={sorted}
        height="300px"
        renderItem={(dealership) => (
          <Grid item xs={4} key={dealership.hash}>
            <Grid item>
              <CustomCard
                id={dealership.id}
                name="dealerships"
                checkbox
                menu={false}
                title={dealership.name}
                subTitle={`Dealership ID : ${dealership.id}`}
                thirdTitle={`${dealership.employeeCount} Employees`}
                width="321px"
                height="80px"
                status={dealership.enabled}
                selected={
                  data?.dealerships?.includes(dealership.id) || data?.dealerships?.includes(dealership.id.toString())
                }
                handleChange={handleDataChange}
              />
            </Grid>
          </Grid>
        )}
      />
    </Grid>
  );
};

export default React.memo(DealershipList);
